import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19eec8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7 user-email"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Change Background", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_14 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isUserAuthenticatedBySpotify && _ctx.spotifyUser)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "Logo",
                src: 
              _ctx.spotifyUser.images && _ctx.spotifyUser.images[0]
                ? _ctx.spotifyUser.images[0].url
                : '/media/avatars/150-26.jpg'
            
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isUserAuthenticatedBySpotify && _ctx.spotifyUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.spotifyUser.display_name), 1),
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.spotifyUser.email), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "align-items-center"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
            return _createVNode(_component_el_col, {
              key: index,
              span: 6,
              class: "mb-5 px-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.setSelectedBackgroundColor(index)),
                  class: _normalizeClass([
              { selected: index === _ctx.selectedBackgroundClassIndex },
              'circle background-gradient-' + index,
            ])
                }, null, 10, _hoisted_12)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}